import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { BaseResponse } from '@models/common.model';
import { ResetPasswordResolver } from '@models/resolver.model';
import { AuthService } from '@services/auth.service';
import { catchError, from, map, of } from 'rxjs';

export const resetPasswordResolver: ResolveFn<ResetPasswordResolver | null> = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const token = route.queryParamMap.get('t');

    if (!token) {
        return from(router.navigate(['/'])).pipe(map(() => null));
    }

    return authService.checkPasswordToken(encodeURIComponent(token)).pipe(
        catchError(() => of(new BaseResponse({ ID: -1 }))),
        map((res) => {
            return {
                verified: res.ID > 0,
                token,
            };
        })
    );
};
